const DOKTER = [
  "Penjelasan penyakit, penyebab, tanda gejala, prognosa dan terapi",
  "Hasil pemeriksaan",
  "Hasil pengobatan",
  "Rencana penatalaksanaan",
  "Hasil yang tak diharapkan",
  "Tindakan medis",
  "Perkiraan hari rawat",
  "Komplikasi",
  "Informed consent",
  "Persiapan operasi",
  "Prosedur pemeriksaan penunjang",
  "Manajemen nyeri",
  "Edukasi lainnya"
];

const PERAWAT = [
  "Pencegahan infeksi : cuci tangan, etika batuk",
  "Pemakaian gelang identitas pasien",
  "Pemakaian gelang risiko jatuh / fall risk",
  "Pemakaian gelang alergi",
  "Rencana asuhan keperawatan",
  "Perawatan luka",
  "Keamanan penggunaan alat kesehatan",
  "Manajemen nyeri",
  "Teknik relaksasi dan distraksi untuk nyeri",
  "Manajemen nyeri kronis jangka panjang",
  "Orientasi ruangan",
  "Persiapan operasi",
  "Prosedur pemeriksaan penunjang",
  "Tindakan pasang infus / NGT / suction / bilas lambung / diet lewat NGT",
  "Tata tertib pasien (pembuangan sampah medis dan non medis, waktu kunjung, larangan merokok, dll)",
  "Pencegahan pasien jatuh",
  "Personal hygiene",
  "Tanda bahaya dan kapan menghubungi fasyankes",
  "Cara penggunaan alat bantu medis di rumah",
  "Pemeliharaan dan sterilisasi alat medis",
  "Alat-alat yang perlu disiapkan di rumah",
  "Hak dan kewajiban pasien dan keluarga",
  "Penyampaian keluhan pasien dan keluarga",
  "Penjelasan DPJP (dokter penanggung jawab pelayanan)",
  "Persiapan persalinan",
  "Pendampingan keluarga",
  "Inisiasi Menyusu Dini (IMD)",
  "ASI eksklusif dan teknik menyusui",
  "Nutrisi ibu nifas",
  "Perawatan perineum",
  "Perawatan bayi baru lahir (BBL)",
  "Keluarga Berencana (KB) pasca salin",
  "Hasil pemeriksaan",
  "Edukasi lainnya"
];

const FARMASI = [
  "Nama obat",
  "Indikasi / khasiat obat",
  "Aturan dan cara pemakaian / pemberian obat",
  "Efek samping obat",
  "Potensi interaksi obat",
  "Edukasi lainnya"
];

const NUTRISIONIST = [
  "Diet dan nutrisi",
  "Konsultasi gizi",
  "Pengelolaan makanan dari luar RS",
  "Edukasi lainnya"
];

const REHABILITASI_MEDIK = [
  "Program dan teknik terapi",
  "Pemeliharaan, pemakaian dan keamanan orthose / protesa",
  "Komunikasi perilaku menelan",
  "Manajemen nyeri non farmakologis",
  "Home program",
  "Edukasi joint protection technique dan proper body mekanik",
  "Edukasi lainnya"
];

const ROHANIAWAN_CARE = [
  "Bimbingan rohani pra tindakan medis",
  "Doa dan motivasi spiritual untuk pasien kritis",
  "Konseling akhir hayat (end-of-life spiritual care)",
  "Edukasi lainnya"
];

const SYARAT_PENJAMINAN =
  "Edukasi syarat penjaminan (BPJS Kesehatan / BPJS Ketenagakerjaan / Taspen / ASABRI / Jamkesda / Jamkesos)";

const MPP = [
  "Edukasi kontrol ke fasyankes sesuai jadwal",
  "Edukasi alternatif penjaminan",
  SYARAT_PENJAMINAN,
  "Edukasi persiapan perawatan lanjutan menjelang pulang dengan kondisi khusus",
  "Edukasi lainnya"
];

const ADMINISTRASI = [
  "Tata tertib RS",
  "Hak berpartisipasi dalam pelayanan",
  "Hak dan kewajiban pasien atau keluarga",
  "Pengurusan administrasi",
  SYARAT_PENJAMINAN,
  "Edukasi kontrol ke fasyankes sesuai jadwal",
  "Edukasi lainnya"
];

const MANAJEMEN_NYERI = [
  "Penilaian skala nyeri (VAS / NRS / Wong-Baker)",
  "Penggunaan analgesik dan kontraindikasi",
  "Teknik relaksasi dan distraksi untuk nyeri",
  "Manajemen nyeri non farmakologis",
  "Manajemen nyeri kronis jangka panjang",
  "Edukasi lainnya"
];

const PENGGUNAAN_ALAT_MEDIS = [
  "Keamanan penggunaan alat kesehatan",
  "Cara penggunaan alat bantu medis di rumah",
  "Pemeliharaan dan sterilisasi alat medis",
  "Alat-alat yang perlu disiapkan di rumah",
  "Edukasi lainnya"
];

export const MATERI_EDUKASI: Record<string, string[]> = {
  Dokter: DOKTER,
  Perawat: PERAWAT,
  Farmasi: FARMASI,
  Nutrisionist: NUTRISIONIST,
  "Rehabilitasi Medik": REHABILITASI_MEDIK,
  "Rohaniawan Care": ROHANIAWAN_CARE,
  MPP: MPP,
  Administrasi: ADMINISTRASI,
  "Manajemen Nyeri": MANAJEMEN_NYERI,
  "Penggunaan Alat Medis": PENGGUNAAN_ALAT_MEDIS
};

const SEMUA_MATERI = Object.keys(MATERI_EDUKASI)
  .reduce((acc: string[], key) => acc.concat(MATERI_EDUKASI[key]), [])
  .filter((nama, i, arr) => arr.indexOf(nama) === i);

export function materiEdukasiFor(profesi: string): string[] {
  return MATERI_EDUKASI[profesi] || SEMUA_MATERI;
}
